exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".two-factor-page {\n  max-width: 720px;\n  margin: 0 auto; }\n  .two-factor-page mat-card {\n    margin-bottom: 24px; }\n  .two-factor-page .qr-code {\n    display: block;\n    width: 220px;\n    max-width: 100%;\n    margin: 0 0 16px;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_f0fbff5b/src/app/main/content/two-factor/two-factor.component.scss
// module id = ../../../../../src/app/main/content/two-factor/two-factor.component.scss
// module chunks = main